import { Injectable } from '@angular/core';
import { LabelTemplate } from '../types/barcodes';
// pdfmake requires assigning vfs from the fonts bundle at runtime
// Use namespace imports to avoid undefined default in certain bundlers
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// Some bundlers expose fonts under vfs directly, others under pdfMake.vfs
const vfs = (pdfFonts as any).vfs || (pdfFonts as any).pdfMake?.vfs;
(pdfMake as any).vfs = vfs;

@Injectable({ providedIn: 'root' })
export class LabelPdfService {
	async generate(template: LabelTemplate, images: Array<{ pngDataUrl: string; text?: string }>): Promise<Blob> {
		const content: any[] = [];
		const tableBody: any[] = [];

		const cols = template.layout.columns;
		const rows = template.layout.rows;
		const cellW = template.layout.cell.width;
		const cellH = template.layout.cell.height;

		let idx = 0;
		for (let r = 0; r < rows; r++) {
			const rowCells: any[] = [];
			for (let c = 0; c < cols; c++) {
				const item = images[idx];
				if (item) {
					rowCells.push({
						width: cellW,
						height: cellH,
						stack: [
							{ image: item.pngDataUrl, width: cellW - 6, alignment: 'center' },
							item.text ? { text: item.text, fontSize: 9, alignment: 'center', margin: [0, 2, 0, 0] } : {}
						]
					});
				} else {
					rowCells.push({ width: cellW, height: cellH, text: '' });
				}
				idx++;
			}
			tableBody.push(rowCells);
		}

		content.push({
			table: {
				widths: new Array(cols).fill(cellW),
				body: tableBody,
			},
			layout: 'noBorders',
			margin: [template.margins.left, template.margins.top, template.margins.right, template.margins.bottom]
		});

		const docDefinition: any = {
			pageSize: { width: template.page.width, height: template.page.height },
			pageMargins: [0, 0, 0, 0],
			content
		};

		return new Promise<Blob>((resolve) => {
			(pdfMake as any).createPdf(docDefinition).getBlob((blob: Blob) => resolve(blob));
		});
	}
}


